import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirst'
})
export class Capitalizefirstletter implements PipeTransform {
  transform(value: string): string {
    if (!value)
    { 
        return '';
    }
    return value.split(' ').map(v => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase()).join(' ');
  }
}
